// extracted by mini-css-extract-plugin
module.exports = {"regulation-link":"_1qKqD","additional-explanation":"_1xCqk","required-field":"_3Jr7f"};